import { Search, SlidersHorizontal } from "lucide-react";
import {
  Table,
  TableBody,
  TableContainer,
  Paper,
} from "@mui/material";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import SignalRow from "./SignalRow";
import { decimalValue } from "../../../core/helper/date-format";

const filters = ["All", "Wins", "Losses", "Trades"];
const SignalsTable = ({ value, data, data2, closedData, coins, percentageFunc, percentageFuturesLongFunc, percentageFuturesShortFunc, coindcxDecimal, page, setPage, totalPages, getSignalClosedData, getSmartPagination }) => {
  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleString();
  };

  const notFound = <h4 className='text-center'>No Signals Yet....!!!!!</h4>
  return (
    <div className="signalView-wrapper">

      <div className="signalView-filters">
        <div className="signalView-filter-left">
          <span className="signalView-filter-label">Filter:</span>
          {filters.map((f, i) => (
            <button
              key={f}
              className={`signalView-filter-btn ${i === 0 ? "signalView-active text-white" : ""
                }`}
            >
              {f}
              {f === "Trades" && (
                <span className="signalView-dropdown-icon">▾</span>
              )}
            </button>
          ))}
        </div>

        <div className="signalView-filter-right">

          {/* Search */}
          <div className="signalView-search">
            <Search className="signalView-search-icon" />
            <input
              placeholder="Search coins..."
              className="signalView-search-input"
            />
          </div>

          {/* Filter icon button */}
          <button className="signalView-icon-btn">
            <SlidersHorizontal className="signalView-icon" />
          </button>

        </div>
      </div>

      <div className="signalView-count">
        <span className="signalView-dot"></span>
        <span className="signalView-count-text">{''} Signals found</span>
      </div>

      <div className="">
        <TableContainer component={Paper} sx={{
          backgroundColor: 'transparent', backgroundImage: 'none',
          // maxHeight: 'calc(50vh - 100px)'
        }}>
          <Table className='signalView-table'>
            <TableBody>
              {
                value === 0 ? <>
                  {!data || data?.length <= 0 ? notFound : data.map((e, i) => {
                    let coindcxDecimalPair = coindcxDecimal[`${e?.coin}${e?.currency}`]

                    let getPrice
                    if (e?.currency === 'INR') {
                      try {
                        getPrice = coins?.INR.find(data =>
                          (data?.pair).includes(e?.coin)
                        )
                      } catch (error) { }
                    } else if (e?.currency === 'USDT') {
                      try {
                        getPrice = coins?.USDT.find(data =>
                          (data?.pair).includes(e?.coin)
                        )
                      } catch (e) { }
                    }
                    const getNetProfit =
                      ((e?.currentPrice - e?.ePrice) / e?.ePrice) * 100
                    const placeNetProfit = getNetProfit
                      ? getNetProfit.toFixed(2)
                      : 0
                    const hitTargetsArr = [];

                    if (e?.t1?.t1Fill) hitTargetsArr.push("T1");
                    if (e?.t2?.t2Fill) hitTargetsArr.push("T2");
                    if (e?.t3?.t3Fill) hitTargetsArr.push("T3");
                    const hitTarget =
                      hitTargetsArr.length > 0
                        ? `Hit ${hitTargetsArr.join(", ")}`
                        : "-";
                    let navigation;
                    if (e?.currency === 'USDT') {
                      navigation = '/spot-usdt/' + e?.coin + '-' + e?.currency

                    } else {
                      navigation = '/spot/' + e?.coin + '_' + e?.currency

                    }
                    const s = {
                      coin: `${e?.coin}/${e?.currency}`,
                      icon: getPrice?.fromCurrency?.image,
                      type: "SPOT",
                      direction: "",
                      navigation: navigation,
                      date: formatDate(e?.createdAt),
                      entry: e?.ePrice,
                      current: decimalValue(
                        e?.currentPrice,
                        coindcxDecimalPair?.base_currency_precision
                          ? coindcxDecimalPair?.base_currency_precision
                          : 0
                      ),
                      profit: `${placeNetProfit}%`,
                      condition: placeNetProfit,
                      hitTarget: hitTarget,

                      progressGreen: Math.max(0, Number(placeNetProfit) || 0).toFixed(2),
                      progressRed: Math.max(
                        0,
                        100 - (Number(placeNetProfit) || 0)
                      ).toFixed(2),

                      targets: [
                        {
                          label: "T1",
                          price: e?.t1?.t1P,
                          percent: `${percentageFunc(e?.t1?.t1P, e?.ePrice)}%`,
                          hit: e?.t1?.t1Fill,
                        },
                        {
                          label: "T2",
                          price: e?.t2?.t2P,
                          percent: `${percentageFunc(e?.t2?.t2P, e?.ePrice)}%`,
                          hit: e?.t2?.t2Fill,
                        },
                        {
                          label: "T3",
                          price: e?.t3?.t3P,
                          percent: `${percentageFunc(e?.t3?.t3P, e?.ePrice)}%`,
                          hit: e?.t3?.t3Fill,
                        },
                        {
                          label: "SL",
                          price: e?.sl?.slP,
                          percent: ((e?.sl?.slP / e?.ePrice) * 100 - 100).toFixed(2) + '%',
                          isSl: false,
                        },
                      ],
                    }

                    return (
                      <SignalRow key={i} {...s} />
                    )
                  })}
                </> : value === 1 ? <>
                  {!data2 || data2?.length <= 0 ? notFound : data2.map((e, i) => {

                    let getNetProfit =
                      ((e?.currentPrice - e?.ePrice) / e?.ePrice) * 100

                    if (e?.side == 'Short/Sell') {
                      getNetProfit = getNetProfit * -1
                    }

                    const placeNetProfit = getNetProfit
                      ? getNetProfit.toFixed(2)
                      : 0

                    const hitTargetsArr = [];

                    if (e?.t1?.t1Fill) hitTargetsArr.push("T1");
                    if (e?.t2?.t2Fill) hitTargetsArr.push("T2");
                    if (e?.t3?.t3Fill) hitTargetsArr.push("T3");

                    const hitTarget =
                      hitTargetsArr.length > 0
                        ? `Hit ${hitTargetsArr.join(", ")}`
                        : "-";
                    const calcFunc =
                      e?.side === "Long/Buy"
                        ? percentageFuturesLongFunc
                        : percentageFuturesShortFunc;

                    const s = {
                      coin: `${e?.coin}/${e?.currency}`,
                      type: "FUTURES",
                      leverage: `${e?.leverage}x`,
                      direction: e?.side === "Long/Buy" ? "Long" : "Short",
                      date: formatDate(e?.createdAt),
                      entry: e?.ePrice,
                      current: e?.currentPrice,
                      profit: `${placeNetProfit}%`,
                      condition: placeNetProfit,
                      navigation: '/futures/trade/' + e?.symbol,
                      hitTarget: hitTarget,

                      progressGreen: Math.max(0, Number(placeNetProfit) || 0).toFixed(2),
                      progressRed: Math.max(
                        0,
                        100 - (Number(placeNetProfit) || 0)
                      ).toFixed(2),

                      targets: [
                        {
                          label: "T1",
                          price: e?.t1?.t1P,
                          percent: `${calcFunc(
                            e?.t1?.t1P,
                            e?.ePrice,
                            e?.leverage
                          )}%`,
                          hit: e?.t1?.t1Fill,
                        },
                        {
                          label: "T2",
                          price: e?.t2?.t2P,
                          percent: `${calcFunc(
                            e?.t2?.t2P,
                            e?.ePrice,
                            e?.leverage
                          )}%`,
                          hit: e?.t2?.t2Fill,
                        },
                        {
                          label: "T3",
                          price: e?.t3?.t3P,
                          percent: `${calcFunc(
                            e?.t3?.t3P,
                            e?.ePrice,
                            e?.leverage
                          )}%`,
                          hit: e?.t3?.t3Fill,
                        },
                        {
                          label: "SL",
                          price: e?.sl?.slP,
                          percent: `${calcFunc(
                            e?.sl?.slP,
                            e?.ePrice,
                            e?.leverage
                          )}%`,
                          isSl: false,
                        },
                      ],
                    };

                    return (
                      <SignalRow key={i} {...s} />
                    )
                  })}
                </> : value === 2 ? <>
                  {!closedData || closedData?.length <= 0 ? notFound : closedData.map((e, i) => {
                    let slPer;

                    let percentageFuncV2
                    if (e?.side === 'Long/Buy') {
                      percentageFuncV2 = percentageFuturesLongFunc
                      slPer = percentageFuturesLongFunc(
                        e?.sl?.slP,
                        e?.ePrice,
                        e?.leverage
                      )
                    } else if (e?.side === 'Short/Sell') {
                      percentageFuncV2 = percentageFuturesShortFunc
                      slPer = percentageFuturesShortFunc(
                        e?.sl?.slP,
                        e?.ePrice,
                        e?.leverage
                      )
                    } else {
                      percentageFuncV2 = percentageFunc
                      slPer = ((e?.sl?.slP / e?.ePrice) * 100 - 100).toFixed(2)
                    }

                    const s = {
                      coin: `${e?.coin}/${e?.currency}`,
                      type: e?.symbol ? "FUTURES" : "SPOT",
                      leverage: e?.leverage ? `${e?.leverage}x` : "",
                      direction:
                        e?.side === "Long/Buy"
                          ? "Long"
                          : e?.side === "Short/Sell"
                            ? "Short"
                            : "",

                      date: formatDate(e?.createdAt),
                      entry: e?.ePrice,

                      profit: `${e?.netProfit?.toFixed(2)}%`,
                      condition: e?.netProfit?.toFixed(2),
                      navigation: e?.symbol ? '/futures/trade/' + e?.symbol : e?.currency === 'USDT' ? '/spot-usdt/' +
                        e?.coin +
                        '-' +
                        e?.currency : '/spot/' + e?.coin + '_' + e?.currency,
                      hitTarget: e?.netProfit > 0 ? "Win" : "Loss",

                      progressGreen: Math.max(0, e?.netProfit || 0).toFixed(2),
                      progressRed: Math.max(0, 100 - (e?.netProfit || 0)).toFixed(2),

                      targets: [
                        {
                          label: "T1",
                          price: e?.t1?.t1P,
                          percent: `${percentageFuncV2(
                            e?.t1?.t1P,
                            e?.ePrice,
                            e?.leverage
                          )}%`,
                          hit: e?.t1?.t1Fill,
                        },
                        {
                          label: "T2",
                          price: e?.t2?.t2P,
                          percent: `${percentageFuncV2(
                            e?.t2?.t2P,
                            e?.ePrice,
                            e?.leverage
                          )}%`,
                          hit: e?.t2?.t2Fill,
                        },
                        {
                          label: "T3",
                          price: e?.t3?.t3P,
                          percent: `${percentageFuncV2(
                            e?.t3?.t3P,
                            e?.ePrice,
                            e?.leverage
                          )}%`,
                          hit: e?.t3?.t3Fill,
                        },
                        {
                          label: "SL",
                          price: e?.sl?.slP,
                          slPer: slPer,
                          percent: `${slPer}%`,
                          isSl: e?.sl?.slFill ? true : false,
                          // isSl: e?.sl?.slFill || Number(slPer) < 0 ? true : false,
                        },
                      ],
                    };

                    return (
                      <SignalRow key={i} {...s} />
                    )
                  })}
                </> : null
              }
            </TableBody>
          </Table>
        </TableContainer>
        {(totalPages > 1 && value === 2) && (
          <div className="d-flex justify-content-center align-items-center gap-2 mt-4 flex-wrap">

            <button
              disabled={page === 1}
              onClick={() => {
                setPage(page - 1)
                getSignalClosedData(page - 1)
              }}
              className="pagination-btn"
            >
              <KeyboardArrowLeftIcon />
            </button>

            {getSmartPagination(page, totalPages).map((p, i) =>
              p === "..." ? (
                <span key={i} className="pagination-dots">...</span>
              ) : (
                <button
                  key={i}
                  onClick={() => {
                    setPage(p)
                    getSignalClosedData(p)
                  }}
                  className={`pagination-btn ${page === p ? "active" : ""}`}
                >
                  {p}
                </button>
              )
            )}

            <button
              disabled={page === totalPages}
              onClick={() => {
                setPage(page + 1)
                getSignalClosedData(page + 1)
              }}
              className="pagination-btn"
            >
              <KeyboardArrowRightIcon />
            </button>

          </div>
        )}
      </div>

    </div>
  );
};

export default SignalsTable;